import React from 'react';
import { API } from '@gin-betting/core';

import { getTournamentCountryCode } from '../../../utils';
import CategorizerCheckRow from '../CategorizerCheckRow';
import CategorizerRowHeader from '../CategorizerRowHeader';
import useCategorizerSubRow from './useCategorizerSubRow';

import './categorizerSubRow.scss';

interface Props {
    label: string;
    topCategorizerItem: API.CategorizerItem;
    countryCode?: string;
    items: API.CategorizerItem[];
    selectedTournamentIds: string[];
    isAllItemsInSportChecked: boolean;
    isGroupWithOneItem: boolean;
    onTournamentIdsChange: (nextTournamentIds: string[]) => void;
    additionalIcon?: JSX.Element | boolean | null;
}

const CategorizerSubRow: React.FC<Props> = ({
    label,
    topCategorizerItem,
    countryCode,
    items,
    selectedTournamentIds,
    isAllItemsInSportChecked,
    isGroupWithOneItem,
    onTournamentIdsChange,
    additionalIcon,
}) => {
    const {
        activeTournamentIds,
        isTournamentCheckable,
        isSubgroupChecked,
        isOpened,
        handleOpenToggle,
        handleTournamentCheck,
        handleSubgroupCheck,
    } = useCategorizerSubRow({
        items,
        topCategorizerItem,
        selectedTournamentIds,
        isAllItemsInSportChecked,
        onTournamentIdsChange,
        isGroupWithOneItem,
    });

    return (
        <div styleName="container">
            <CategorizerRowHeader
                hasBorder={false}
                label={label}
                countryCode={countryCode}
                isOpened={isOpened}
                isSelected={isSubgroupChecked}
                onClick={handleOpenToggle}
                onSelect={handleSubgroupCheck}
                additionalIcon={additionalIcon}
            />

            {isOpened && (
                <div styleName="list">
                    {items.map(item => {
                        const { name, value, count } = item;
                        const isChecked =
                            activeTournamentIds.includes(value) &&
                            isTournamentCheckable;

                        const itemCountryCode = countryCode
                            ? undefined
                            : getTournamentCountryCode(item, true);

                        return (
                            <CategorizerCheckRow
                                key={value}
                                title={name}
                                id={value}
                                checked={isChecked}
                                onClick={handleTournamentCheck}
                                count={count}
                                countryCode={itemCountryCode}
                            />
                        );
                    })}
                </div>
            )}
        </div>
    );
};

export default CategorizerSubRow;
